var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoModalPoint3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#E9F7F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(8.5 8)",
    fill: "#E9F7F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5312V16L15.4375 19.6562C15.75 19.9062 16.0938 20 16.5 20C16.875 20 17.2188 19.9062 17.5312 19.6562L22.5 16V14.5312L16.5 10.0625L10.5 14.5312ZM16.5 8C16.875 8 17.2188 8.125 17.5312 8.34375L23.6875 12.9062C24.1875 13.2812 24.5 13.875 24.5 14.5312V22C24.5 23.125 23.5938 24 22.5 24H10.5C9.375 24 8.5 23.125 8.5 22V14.5312C8.5 13.875 8.78125 13.2812 9.28125 12.9062L15.4375 8.34375C15.75 8.125 16.0938 8 16.5 8Z",
    fill: "#24B275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModalPoint3);
export default __webpack_public_path__ + "static/media/info-modal-point3.553513c11c962fa1f64e5fb66040b4fc.svg";
export { ForwardRef as ReactComponent };